export * as feedNaming from './feedNaming';
export * as processNotfications from './processAccordingNotificationType';
export * as processPosts from './processAccordingPostType';
export enrichedAssign from './enrichedAssign';
export getDenormalizer from './getDenormalizer';
export omit from './omit';
export stripTags from './stripTags';
export uniq from './uniq';



// WEBPACK FOOTER //
// ./~/virgo/src/utils/index.js